import {gql, useMutation} from "@apollo/client";

const SAVE_INNING_SCORE = gql`
    mutation SaveInningScore($profileId: Int!, $gameId: Int!, $inningScores: GenericScalar!, $eventStatus: String) {
        saveInningScore(profileId: $profileId, gameId: $gameId, inningScores: $inningScores, eventStatus: $eventStatus) {
            event {
                id
                status
                game {
                    id
                    scoreHome
                    scoreVisitor
                    penaltiesHome
                    penaltiesVisitor
                    inningScores {
                        inning
                        scoreHome
                        scoreVisitor
                    }
                }
            }
        }
    }
`;

export default function SaveInningScoreMutation() {
    return useMutation(SAVE_INNING_SCORE);
}
